module.exports = __webpack_public_path__ + "static/img/materials4.fd656b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials4.png
// module id = xZ8R
// module chunks = 2